import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {useLocation, matchPath} from 'react-router-dom';
import {PAGE_ID} from 'Core/ducks/analytics';
import {isAuthenticated} from 'Shared/utilities/Auth';

//@ts-ignore: the original window object does not have digitalData property
window.digitalData = window.digitalData || {};

export const getCurrentPage = (location: string) => {
  if (isPath(location, {path: '/agent/policies/:policyId/policyNumber/:policyNumber'})) return 'agentPoliciesDetails';
  if (isPath(location, {path: '/agent/accounts/:accountId/accountNumber/:accountnumber'}))
    return 'agentAccountViewDetails';
  if (isPath(location, {path: '/agent/policies/:policyId/policyNumber/:policyNumber/upload'}))
    return 'agentPoliciesUploadDocument';
  if (isPath(location, {path: '/agent/policies/:policyNumber/claims'})) return 'agentPoliciesViewClaims';

  return location;
};

const isPath = (location: string, props: any) => {
  let matchResult: any = matchPath(location, props);
  if (matchResult !== null) {
    return matchResult.isExact;
  }
  return matchResult;
};

const Analytics = () => {
  const isUserAuthenticated = isAuthenticated();
  const dispatch = useDispatch();
  const location = useLocation();
  const {analytics} = useSelector((state: ReducerState) => state.analytics);

  useEffect(() => {
    const currentPage = getCurrentPage(location.pathname);

    if (Object.keys(analytics).length > 1) {
      if (performance.navigation.type === 0) {
        //@ts-ignore: the original window object does not have digitalData property
        Object.assign(window.digitalData, {...analytics});

        //@ts-ignore: the original window object does not have satellite property
        if (window._satellite) window._satellite.track('DCR_LinkClick');

        const delayDebounceFn = setTimeout(() => {
          //@ts-ignore: the original window object does not have satellite property
          if (window._satellite)
            //@ts-ignore: the original window object does not have digitalData property
            Object.assign(window.digitalData, {
              page: {
                pageId: PAGE_ID[currentPage],
              },
            });

          //@ts-ignore: the original window object does not have satellite property
          window._satellite.track('DCR_PageLoad');
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
      }
    } else {
      //@ts-ignore: the original window object does not have digitalData property
      Object.assign(window.digitalData, {
        page: {
          pageId: PAGE_ID[currentPage],
        },
      });

      //@ts-ignore: the original window object does not have satellite property
      if (window._satellite) window._satellite.track('DCR_PageLoad');
    }
  }, [analytics]);
  return null;
};

export default Analytics;
